import { ContatoPainel, Footer, Header } from '../../molecules'

export function ContatoTemplate() {
  return (
    <>
      <Header />
      <ContatoPainel />
      <Footer />
    </>
  )
}
